import React, { useEffect, useState } from "react";
import EditorNew from "../../../Editor/EditorNew";
import Radio from "rsuite/esm/Radio";
import RadioGroup from "rsuite/esm/RadioGroup";
import { getCookie } from "../../../common/Utility";
import NoteSingle from "./NoteSingle";

const NotesPanel = ({
  customerTattleUUID,
  mauticId,
  usersList,
  attribute_set_key = "contacts",
  attribute_set_type = 5,
  showFooterPanel = true,
  customerName = "",
}) => {
  let user_uuid =
    getCookie("muvi_useruuid") || "";
  const [noteType, setNoteType] = useState("internal");
  const [errorMessage, setErrorMessage] = useState("");
  const [noteContent, setNoteContent] = useState("");
  const [editId, setEditId] = useState(0);
  const [noteAdding, setNoteAdding] = useState(0);
  const [crmNotes, setCrmNotes] = useState([]);
  const [copyNotesLink, setCopyNotesLink] = useState("");

  useEffect(() => {}, []);

  useEffect(() => {
    getCrmNotes();
  }, [customerTattleUUID, mauticId]);

  const getActiveUserList = () => {
    return Object.keys(usersList)
      .filter((key) => usersList[key].is_active === 1)
      .reduce((acc, key) => {
        acc[key] = usersList[key];
        return acc;
      }, {});
  };

  const handleNoteTypeChange = (type) => {
    setNoteType(type);
  };

  const addChatNote = (chatData) => {
    setNoteContent(chatData);
  };

  const getCrmNotes = () => {
    if (!mauticId && !customerTattleUUID) {
      setCrmNotes([]);
      return;
    }

    const output = fetch(`${process.env.REACT_APP_tattle_api}/notes/list`, {
      method: "POST",
      body: JSON.stringify({
        customer_tattle_uuid: Number(mauticId || customerTattleUUID),
        attribute_set_key: attribute_set_key,
        app_token: process.env.REACT_APP_tattle_token,
        attribute_set_type,
      }),
    });

    output
      .then((i) => {
        return i.json();
      })
      .then((out) => {
        setCrmNotes(out.data || []);
      })
      .catch((error) => {
        console.error("Fetch error:", error.message);
        // Handle fetch error
      });
  };

  const noteAdd = (e) => {
    e.preventDefault();
    setNoteAdding(1);
    setEditId((prev) => prev + 1);

    const mentionIds = noteContent.mentioned_data;
    if (noteContent && noteContent.chat_note.html_content == "") {
      setErrorMessage("Please fill the field *");
      setNoteAdding(0);
      return false;
    } else {
      setErrorMessage("");
      setNoteContent("");
      const note = noteContent.chat_note.html_content;

      fetch(`${process.env.REACT_APP_CRM}/crm/add-note`, {
        method: "POST",
        body: JSON.stringify({
          attribute_set_key: attribute_set_key,
          app_token: process.env.REACT_APP_tattle_token,
          customer_tattle_uuid: Number(mauticId || customerTattleUUID),
          user_uuid: user_uuid || "",
          note_content: note,
          note_content_json:
            noteContent.chat_note.draft_js_content &&
            noteContent.chat_note.draft_js_content,
          mention: mentionIds && mentionIds,
          note_type: noteType,
          attribute_set_type,
          // mautic_id: mauticId,
        }),
      })
        .then((item) => {
          return item.json();
        })
        .then((data) => {
          setNoteAdding(0);
          getCrmNotes();
        })
        .catch((error) => {
          console.error("Fetch error:", error.message);
          // Handle fetch error
        });
    }
  };

  const noteEditorFooterPanel = () => {
    const options = [
      { label: "Internal", value: "internal" },
      { label: "Customer", value: "external" },
    ];
    if (!showFooterPanel) return;

    return (
      <RadioGroup
        name="note-type"
        inline
        value={noteType}
        onChange={(value) => handleNoteTypeChange(value)}
      >
        <Radio value="internal">Internal</Radio>
        <Radio value="external">Customer</Radio>
      </RadioGroup>
    );

  };

  return (
    <div role="tabpanel" class={`tab-pane ${attribute_set_key}`} id="notes">
      <div class="full-chat-area">
        <div class="chat-middle">
          <div class="tab-content" style={{ height: "100%" }}>
            <div class="note-viewarea p-8">
              <form class="form-area ps-0 pe-0">
                {Object.keys(usersList).length > 0 && (
                  <EditorNew
                    getEditorData={addChatNote}
                    noteAdd={noteAdd}
                    show_toolbar={true}
                    field_name="chat_note"
                    edit_id={editId}
                    noteAdding={noteAdding}
                    users={getActiveUserList()}
                    footerComponent={noteEditorFooterPanel}
                  />
                )}
                {errorMessage && (
                  <label className="note-error-msg">{errorMessage}</label>
                )}
              </form>
              <div class="note-content-area ps-5 pe-5 scrollable scrollable-y">
                {crmNotes.length > 0 &&
                  crmNotes.map((item) => (
                    <NoteSingle
                      key={item.custom_note_uuid}
                      item={item}
                      usersList={usersList}
                      copyNotesLink={copyNotesLink}
                      setCopyNotesLink={setCopyNotesLink}
                      mauticId={mauticId}
                      customerName={customerName}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesPanel;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/NotesPanel.js